import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';
import SuggestList from './SuggestList';
import wsStore from './store';
import { observer } from 'mobx-react-lite';
import { SVGPureIcon } from '@/ui/svg-icon';
import { useEffect } from 'react';
import { HelperCore } from "@/common/helper";
import appLogger from '@public/log/monitor';
import client from '@/store/client';

function Welcome(props) {
  const store = wsStore;
  const { className } = props;
  const { welcomeMessage, recommendMessages } = store.cloudConfig;

  useEffect(() => {
    store.loadCloudConfig();
  }, []);

  return (
    <div className={["relative size-full pt-[10vh] flex flex-col items-center", className]}>
      {store.hasNoChat ? null : (
        <span
          className={[
            'cursor-pointer',
            'absolute top-12px',
            'flex items-center gap-[6px]',
            'text-[12px] text-black text-opacity-30 hover:text-opacity-50',
          ]}
          onClick={
            () => {
              appLogger.log({
                key : "aibot_plugin",
                action : "click",
                arrt : "aibot_plugin_sidebar_last_chat",
              });
              store.loadLastChat();
            }
          }
        >
          继续上次对话
          <SVGPureIcon name="icon_double_down" className="w-[9px] h-[8px] transform rotate-180" />
        </span>
      )}
      <div className="h-0 flex-grow flex flex-col items-center justify-center">
        <img className='h-50px' src="https://p5.ssl.qhimg.com/t11098f6bcd3c3f341519432e67.jpg" />
        <div className="mt-16px text-center w-full text-black text-16px leading-26px">
          我可以帮你搜索、答疑、写作和分析<br />
          请把任务交给我吧~
        </div>
      </div>
      {/* <div className="w-full mt-[32px] flex flex-wrap justify-center gap-[8px]">
        {recommendMessages.map(x => {
          return (
            <div
              key={x.function_name}
              className="w-[calc(50%-4px)] h-[48px] pl-[20px] rounded-[12px] bg-[#F6F7F9] hover:bg-[#F0F2F5] flex items-center gap-[10px] cursor-pointer"
              onClick={() => {
                appLogger.log({
                  key : "aibot_plugin",
                  action : "click",
                  arrt : "aibot_plugin_sidebar_config_card",
                  ext : x.function_name,
                  ext1 : x.function_url,
                });
                client.run("OpenUrl", null, x.function_url);
              }}
            >
              <div
                className="w-[21px] h-[26px] text-[14px] truncate font-bold"
                style={{
                  background: `url(${x.function_icon_url}) center center/100% no-repeat`,
                }}
              ></div>
              <div className="font-bold">{x.function_name}</div>
            </div>
          );
        })}
      </div> */}
      <SuggestList className="mb-32px" />
    </div>
  );
}

export default observer(Welcome);
